var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStopMinusOctagon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10H7.5",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69036 16.5237L3.47631 14.3096C2.85119 13.6845 2.5 12.8367 2.5 11.9526V8.04821C2.5 7.16416 2.85119 6.31631 3.47631 5.69119L5.69119 3.47631C6.31631 2.85119 7.16416 2.5 8.04821 2.5H11.9518C12.8358 2.5 13.6837 2.85119 14.3088 3.47631L16.5237 5.69119C17.1488 6.31631 17.5 7.16416 17.5 8.04821V11.9527C17.5 12.8366 17.149 13.6843 16.524 14.3094L14.3108 16.5233C13.6856 17.1487 12.8376 17.5 11.9534 17.5H8.04737C7.16332 17.5 6.31548 17.1488 5.69036 16.5237Z",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStopMinusOctagon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stopMinusOctagon.f7f7b413.svg";
export { ForwardRef as ReactComponent };